import * as e from "react";
import a from "../lib/SSRBase.es.js";
import m from "../defs/Cube.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(a, { ref: t, ...r, weights: m }));
o.displayName = "CubeIcon";
const f = o;
export {
  f as Cube,
  o as CubeIcon
};
